'use strict';

/**
 * @ngdoc service
 * @name ntmApp.ListGridConfirmationService
 * @description
 * # ListGridConfirmationService
 * Service in the ntmApp.
 */

angular.module('ntmApp')
  .factory('ListGridConfirmationService', ['ConfirmationService', 'Utils', function (ConfirmationService, Utils) {

      function scenarioGenerating() {
          return Utils.OpenModal('', 'ng1/src/staffForecasting/confirmations/popups/newScenarioLoadingPopup.html', null, null, null, null, true);
      }

      function deleteWarning() {
          return new ConfirmationService.YesNoConfirmation('Are you sure you want to delete?', 'ng1/src/listGrid/views/confirmations/deleteWarning.html');
      }

      var service = {};

      angular.extend(service, ConfirmationService);
      service.ScenarioGenerating = scenarioGenerating;
      service.DeleteWarning = deleteWarning;

      return service;

  }]);